import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'

import { ReactComponent as ErrorIcon } from 'images/icons/error-icons/circle-outlined-error.svg'

const useStyles = makeStyles(theme => ({
  container: {
    alignItems: 'center',
    background: theme.colors.redLightest,
    border: `1px solid ${theme.colors.redDarker}`,
    borderRadius: 4,
    display: 'flex',
    height: 72,
    marginBottom: 24,
    padding: 24,
    width: '100%',
  },
  icon: {
    height: 26,
    marginRight: 18,
    width: 26,
  },
}))

function ErrorBox({ value }) {
  const classes = useStyles()

  return (
    <div className={classes.container}>
      <ErrorIcon className={classes.icon} />
      {value}
    </div>
  )
}

ErrorBox.propTypes = {
  value: PropTypes.string.isRequired,
}

export default ErrorBox
